import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as g from 'src/app/globals';

interface AuthUrlResponse {
  authUrl: {
    Item1: string;
    Item2: string;
  };
  codeVerifier?: string;
}
interface ExchangeResponse {
  userId: string;
}

@Injectable({ providedIn: 'root' })
export class MsGraphService {
  // Put your API base here (no trailing slash), e.g. 'https://yourserver.com'
  private readonly baseUrl = g.apiBaseUrl + '/msgraph';

  constructor(private http: HttpClient) {}

  getAuthenticationUrl(email: string): Observable<AuthUrlResponse> {
    const params = new HttpParams().set('email', email);

    return this.http.get<AuthUrlResponse>(`${this.baseUrl}/GetAuthenticationUrl`, { params });
  }

  exchangeCode(code: string, state: string): Observable<ExchangeResponse> {
    const params = new HttpParams().set('code', code).set('state', state);
    return this.http.get<ExchangeResponse>(`${this.baseUrl}/ExchangeCode`, { params });
  }
}
